module.exports = __webpack_public_path__ + "static/media/hero_landing.87d9a77c.jpg";